import {ReactNode} from "react";
import classNames from "classnames";

export interface ListItemProps {
  className?: string;
  children: ReactNode;
}

export const ListItem = ({className, children}: ListItemProps) => {
  return (
    <li className={classNames(className, "first:mt-2 first:md:mt-4")}>
      {children}
    </li>
  );
};
